import { useEffect, useState } from "react";
import axios from "axios";
import { getAuthHeader } from "../utils/authHeader";
import { ZapcapUsageStatus } from "../types/zapcapUsage";

export interface UseZapcapUsageReturn {
    usage: ZapcapUsageStatus | null;
    loading: boolean;
}

/**
 * Fetches the current user's ZapCap captioning usage once on mount.
 * Non-blocking: on failure `usage` stays null and consumers render a placeholder.
 */
export const useZapcapUsage = (): UseZapcapUsageReturn => {
    const [usage, setUsage] = useState<ZapcapUsageStatus | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        let active = true;
        const fetchUsage = async (): Promise<void> => {
            try {
                const authHeader = await getAuthHeader();
                const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
                const res = await axios.get<ZapcapUsageStatus>(
                    `${backendUrl}/usage/zapcap-status`,
                    { headers: authHeader }
                );
                if (active) setUsage(res.data);
            } catch {
                // Non-blocking: leave usage null so the consumer shows a placeholder.
            } finally {
                if (active) setLoading(false);
            }
        };
        fetchUsage();
        return () => {
            active = false;
        };
    }, []);

    return { usage, loading };
};
